import React from 'react';
import { Box, Button, Container, Paper, Typography } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import authService from '../services/authService';

const LoginPage: React.FC = () => {
  const handleGoogleLogin = () => {
    authService.loginWithGoogle();
  };

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fff',
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            padding: { xs: 2.5, sm: 4 },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: 2,
          }}
        >
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 'bold',
              color: 'primary.main',
              marginBottom: 1,
            }}
          >
            NSTA CRM
          </Typography>

          <Typography
            variant="h6"
            color="text.secondary"
            sx={{ marginBottom: 4, textAlign: 'center' }}
          >
            Ласкаво просимо! Увійдіть, щоб продовжити
          </Typography>

          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Button
              variant="contained"
              size="large"
              startIcon={<GoogleIcon />}
              onClick={handleGoogleLogin}
              sx={{
                minWidth: 250,
                padding: '12px 24px',
                fontSize: '1rem',
                textTransform: 'none',
                backgroundColor: '#fff',
                color: '#757575',
                border: '1px solid #dadce0',
                '&:hover': {
                  backgroundColor: '#f8f9fa',
                  boxShadow: '0 1px 3px 0 rgba(60,64,67,0.3)',
                },
              }}
            >
              Увійти через Google
            </Button>

            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ marginTop: 2, textAlign: 'center', maxWidth: 350 }}
            >
              Входячи, ви погоджуєтесь з нашими Умовами використання та Політикою конфіденційності
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default LoginPage;
